import * as Auth from '../services/Auth.Service';
import * as factory from '../services/Request.Factory';
let config = require('../base/URL.Config').config();

/**
 * Demo Function to get some info
 * @returns {JSON object} JSON object, each item is a post
 */
export function GetItem(id) {
	let data = {
		item_id: id
    };

	let base = config.URL.API.BASE;
	let url = base + config.URL.API.ITEMS.read;
	let request = new factory.Request();

	let response = request.Get('', url, data, 'AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw');
	return response;
}

export function GetUserActivity(id) {
	let data = {
		item_id: id,
		type: "up_fave"
    };

	let base = config.URL.API.BASE;
	let url = base + config.URL.API.ITEMS.read_activity;
	let request = new factory.Request();

	let response = request.Get('', url, data, 'AIzaSyAvHNjBjfg5WfcMdGz0MSwTaXcGowIgmHw');
	return response;
}




// WEBPACK FOOTER //
// ./src/client/services/Items.Service.js